import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Nav } from '@/components/Nav';
import { Footer } from '@/components/Footer';
import { api } from '@/lib/api';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';

export default function PaymentSuccess() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const sessionId = params.get('session_id');
    const [state, setState] = useState('polling'); // polling | paid | failed | expired
    const [tx, setTx] = useState(null);
    const attempts = useRef(0);

    useEffect(() => {
        if (!sessionId) { navigate('/'); return; }
        let stopped = false;

        const poll = async () => {
            if (stopped) return;
            attempts.current += 1;
            try {
                const { data } = await api.get(`/payments/status/${sessionId}`);
                setTx(data);
                if (data.payment_status === 'paid') { setState('paid'); return; }
                if (['failed', 'expired'].includes(data.payment_status)) { setState(data.payment_status); return; }
            } catch {}
            if (attempts.current >= 15) { setState('failed'); return; }
            setTimeout(poll, 2000);
        };
        poll();
        return () => { stopped = true; };
    }, [sessionId, navigate]);

    return (
        <div className="bg-[#050505] min-h-screen text-[#F8F8F5]">
            <Nav />
            <div className="max-w-3xl mx-auto px-6 md:px-12 py-32 text-center">
                {state === 'polling' && (
                    <>
                        <Loader2 size={48} className="text-[#C5A059] mx-auto mb-8 animate-spin" />
                        <div className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">Vérification</div>
                        <h1 className="font-display text-4xl font-light">Confirmation du paiement...</h1>
                    </>
                )}
                {state === 'paid' && (
                    <>
                        <CheckCircle2 size={64} className="text-[#C5A059] mx-auto mb-8" />
                        <div className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">Acompte confirmé</div>
                        <h1 className="font-display text-4xl md:text-5xl font-light mb-6">Merci pour votre <em className="text-[#C5A059] not-italic">confiance</em></h1>
                        <p className="text-[#A3A39D]">Acompte réglé : <span className="text-[#F8F8F5]">10,00 €</span></p>
                        <p className="text-[#A3A39D] mt-2">Cet acompte, non remboursable, sera déduit du prix de la course lors du règlement au chauffeur (espèces / carte / chèque).</p>
                        <p className="text-[#A3A39D] mt-2">Nous vous contacterons rapidement pour confirmer.</p>
                        <div className="mt-12 flex gap-4 justify-center flex-wrap">
                            <button data-testid="payment-home-btn" onClick={() => navigate('/')} className="border border-[#222] hover:border-[#C5A059] text-[#F8F8F5] px-8 py-3 text-xs uppercase tracking-[0.25em]">Accueil</button>
                            <button data-testid="payment-account-btn" onClick={() => navigate('/mon-compte')} className="bg-[#C5A059] text-black px-8 py-3 text-xs uppercase tracking-[0.25em]">Mes réservations</button>
                        </div>
                    </>
                )}
                {(state === 'failed' || state === 'expired') && (
                    <>
                        <XCircle size={64} className="text-red-400 mx-auto mb-8" />
                        <h1 className="font-display text-4xl font-light mb-6">Paiement non abouti</h1>
                        <p className="text-[#A3A39D]">Aucun montant n'a été débité. Vous pouvez réessayer.</p>
                        <button onClick={() => navigate('/reservation')} className="mt-8 bg-[#C5A059] text-black px-8 py-3 text-xs uppercase tracking-[0.25em]">Nouvelle réservation</button>
                    </>
                )}
            </div>
            <Footer />
        </div>
    );
}
